import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { RegionsQueryResponse, Regions400, Regions401, Regions403, Regions404, Regions410, Regions422, Regions429, Regions500 } from "../types/Regions";

export const regionsQueryKey = () =>     [{url:`/api/sberbank-integration/regions`}] as const;
      export function regionsQueryOptions <TData = RegionsQueryResponse, TError = Regions400 | Regions401 | Regions403 | Regions404 | Regions410 | Regions422 | Regions429 | Regions500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = regionsQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/sberbank-integration/regions`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/sberbank-integration/regions
 */

export function useRegions <TData = RegionsQueryResponse, TError = Regions400 | Regions401 | Regions403 | Regions404 | Regions410 | Regions422 | Regions429 | Regions500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? regionsQueryKey();

  const query = useQuery<TData, TError>({
    ...regionsQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
